export default {
  view: 'supplier.view_vendor',
  add: 'supplier.add_vendor',
  change: 'supplier.change_vendor',
  delete: 'supplier.delete_vendor',
  export: 'supplier.export_vendor',
  import: 'supplier.import_vendor',
};
